import {
  documentDetailsService,
  documentFullTextSearchService,
  filterCriteriaService,
  getDocumentsService,
  getDocumentCategoryService,
  getDocumentTypeService,
  getPersonsService,
  getFavoriteFiltersService,
  documentUploadStatus,
} from 'components/Dashboard/Documents/services/documentServices';
import {
  getFilterCriteria,
  filteredDocuments,
  filterFailed,
  documentDetailsState,
  getDocumentDetailFailed,
  getSearchResult,
  searchResultState,
  getSearchResultFailed,
  getDocumentList,
  getPersons,
  listDocumentsState,
  getDocumentListFailed,
  onFiltering,
  getDocumentCategory,
  getDocumentTypes,
  getFavoriteFilters,
  getFavoriteFiltersFailed,
  listFavoriteFiltersState,
  taskId,
  uploadStatus,
  minimumLoadTimeReached,
} from './documentSlice';

export const filterCriteriaThunk = (filter_param) => async (dispatch) => {
  try {
    const cleanedParams = Object.entries(filter_param).reduce(
      (acc, [key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          acc[key] = value;
        }
        return acc;
      },
      {},
    );

    dispatch(getFilterCriteria());

    const data = await filterCriteriaService(cleanedParams);

    dispatch(filteredDocuments(data));
  } catch (error) {
    dispatch(filterFailed());
  }
};

export const onFilterCriteriaThunk = (isFiltering) => async (dispatch) => {
  try {
    dispatch(onFiltering(isFiltering));
  } catch (error) {
    throw error;
  }
};

export const documentDetailsThunk = (id) => async (dispatch) => {
  try {
    const data = await documentDetailsService(id);

    dispatch(documentDetailsState(data));
  } catch (error) {
    dispatch(getDocumentDetailFailed());
  }
};

export const documentClearDetailsThunk = () => async (dispatch) => {
  try {
    dispatch(documentDetailsState({}));
  } catch (error) {
    dispatch(getDocumentDetailFailed());
  }
};

export const fullTextSearchThunk = (search_query) => async (dispatch) => {
  try {
    dispatch(getSearchResult());

    const data = await documentFullTextSearchService(search_query);

    dispatch(searchResultState(data));
  } catch (error) {
    dispatch(getSearchResultFailed());
  }
};

export const listDocumentsThunk = () => async (dispatch) => {
  const MIN_LOADING_TIME = 10000; // 1 second minimum loading time

  try {
    dispatch(getDocumentList());

    const loadingTimer = setTimeout(() => {
      dispatch(minimumLoadTimeReached());
    }, MIN_LOADING_TIME);

    const data = await getDocumentsService();

    clearTimeout(loadingTimer);
    dispatch(listDocumentsState(data));
    dispatch(minimumLoadTimeReached());
  } catch (error) {
    dispatch(getDocumentListFailed(error.message));
    dispatch(minimumLoadTimeReached());
  }
};

export const listDocumentCategoriesThunk = () => async (dispatch) => {
  try {
    const data = await getDocumentCategoryService();

    dispatch(getDocumentCategory(data));
  } catch (error) {
    throw error;
  }
};

export const listDocumentTypesThunk = () => async (dispatch) => {
  try {
    const data = await getDocumentTypeService();

    dispatch(getDocumentTypes(data));
  } catch (error) {
    throw error;
  }
};

export const listPersonsThunk = () => async (dispatch) => {
  try {
    const data = await getPersonsService();

    dispatch(getPersons(data));
  } catch (error) {
    throw error;
  }
};

export const listFavoriteFiltersThunk = () => async (dispatch) => {
  try {
    dispatch(getFavoriteFilters());

    const data = await getFavoriteFiltersService();

    dispatch(listFavoriteFiltersState(data));
  } catch (error) {
    dispatch(getFavoriteFiltersFailed());

    throw error;
  }
};

export const getTaskIdThunk = (task_Id) => (dispatch) => {
  dispatch(taskId(task_Id));
};

export const uploadStatusThunk = (task_id) => async (dispatch) => {
  try {
    // console.log('calling [uploadStatusThunk]');
    const status = await documentUploadStatus(task_id);
    // console.log('calling [uploadStatusThunk]: ', status);
    dispatch(uploadStatus(status));
  } catch (error) {
    dispatch(uploadStatus('failed'));
    console.error('[uploadStatusThunk] error: ', error);
    throw error;
  }
};
